import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';
import { LoginService } from './login.service';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/merge';

@Injectable()
export class AutosuggestService {
  private appURL: string = environment.apiUrl;
  constructor(private _jsonp: HttpClient, private loginservice: LoginService) { }

  getEmployeeslist(term, currUser, currentOrgs) {

    if (term === '') {
      return Observable.of([]);
    }
    if (currUser === '') {
      return Observable.of([]);
    }

    /*if (currentOrgs === '') {
      return Observable.of([]);
    }*/

    const search: any = [];
    const currUsers: any = [];
    const currentOrg: any = [];

    return this._jsonp.post(this.appURL + 'getEmployeeList', JSON.stringify({ search: term, currUsers: currUser, currentOrg: currentOrgs }))
      .map(response => <string[]>response['e_names']);
  }

  getEmpforApp(term, jobid, currentOrgs) {
    if (currentOrgs === '') {
      return Observable.of([]);
    }
    const search: any = [];
    const currentOrg: any = [];
    return this._jsonp.post(this.appURL + 'getEmpforApp', JSON.stringify({ search: term, job_id: jobid, currentOrg: currentOrgs }))
      .map(response => <string[]>response['e_names']);
  }

  getContractorNames(term, parentChild, option = '') {
    if (term === '') {
      return Observable.of([]);
    }
    let currentOrg = JSON.parse(this.loginservice.getLocalSession('currentOrg'));
    const search: any = [];
    return this._jsonp.post(this.appURL + 'getContractorNames', JSON.stringify({ search: term, currOrg: currentOrg, parentChild: parentChild, option: option }));

  }

  uploadFile(formData: any) {
    return this._jsonp.post(this.appURL + 'upload.php', formData);
  }

}



// WEBPACK FOOTER //
// ./src/app/autosuggest.service.ts